import React from 'react';
import logo from '../../assets/images/legion.png';
import './_header.scss';

const Header = () => {
  return (
    <>
      <div className="header-container">
        <div className="logo">
          <img src={logo} className="logo-img" height="37" width="100" alt="Legion" />
        </div>
        {/* <div className="title">Legion</div> */}
      </div>
    </>
  );
};

export default Header;
